import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, delay, retry, shareReplay, take } from 'rxjs';
import { MyNotificationTopic } from 'src/models/notification';
import { NotificationSubscription } from 'src/models/notificationSubscription';
import { AppSettings } from '../app-settings';
import { NotificationHistory, NotificationRequest, NotificationType } from 'src/models/notificationRequest';
import { Device } from '@capacitor/device';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient, private appSettings: AppSettings) { }

    getSubscribedTopicsByProfileId(profileId: number, token: string): Observable<MyNotificationTopic[]> {
        let url = this.appSettings.apiBaseUrl() + 'Notification/GetSubscribedTopicsByProfileId?profileId=' + profileId + "&token=" + token;

        return this.http.get<MyNotificationTopic[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    getMyNotificationSubscription(profileId: number): Observable<NotificationSubscription[]> {
        let url = this.appSettings.apiBaseUrl() + 'Notification/GetUserSubscription?userId=' + profileId;

        return this.http.get<NotificationSubscription[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    updateNotificationSubscription(notificationGroupId: number, isUnSubscribed: boolean, userId: number): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + 'Notification/UpdateUserSubscription?userId=' + userId
            + "&notificationGroupId=" + notificationGroupId + "&isUnsubscribed=" + isUnSubscribed;

        return this.http.get<boolean>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    updateNotificationReadStatus(messageId: number): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + 'Notification/updateNotificationReadStatus?messageId=' + messageId

        return this.http.get<boolean>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }), shareReplay());
    }

    sendMessageNotification(request: NotificationRequest): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + `Notification/SendNotification`;

        return this.http.post<boolean>(url, request, this.httpOptions)
            .pipe(
                retry({ count: 1, delay: 500 }), shareReplay());
    }

    sendClassNotification(request: NotificationRequest): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + `Notification/SendClassNotification`;

        return this.http.post<boolean>(url, request, this.httpOptions)
            .pipe(
                retry({ count: 1, delay: 500 }), shareReplay());
    }

    getNotificationHistory(notificationTypeId: NotificationType, rowPrimaryKey: number): Observable<NotificationHistory[]> {
        let url = this.appSettings.apiBaseUrl() + `Notification/GetNotificationHistory?skipLoadingSpinner=1&typeId=${notificationTypeId}&rowPrimaryKey=${rowPrimaryKey}`;

        return this.http.get<NotificationHistory[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 1, delay: 500 }), shareReplay());
    }

    sendSms(phoneNumbers: string, body: string) {
        Device.getInfo().then(info => {
            let href = `sms:${phoneNumbers}?&body=${encodeURIComponent(body)}`;

            if (info.platform === 'ios' || info.operatingSystem === 'ios') {
                href = `sms:/open?addresses=${phoneNumbers}&body=${encodeURIComponent(body)}`;
            }

            const myLink = document.createElement('a');
            myLink.href = href;
            myLink.click();
        });
    }

}